import React from 'react'

import PageVariablesEditorFrame from '@Components/Mergetag/PageVariablesEditorFrame'
import CodeEditor from 'components/form/CodeEditor';

const AdvancedTab = ({ disabled, value, handleChangeContent }) => <>
  <PageVariablesEditorFrame mode='html' disabled={disabled}>
    <CodeEditor
      disabled={disabled}
      readOnlyMessage='You can not edit the content in version view.'
      name="content"
      value={value}
      className='h-[40vh]'
      onChange={handleChangeContent}
      language="html"
    />
  </PageVariablesEditorFrame>
</>

export default AdvancedTab;
